<template>
  <div>
    <p v-if="selected"><b>Selected:</b> {{ selected.id }}</p>
    <b-field label="Angebot suchen">
      <b-autocomplete
        :data="data"
        placeholder="Hotelname, Angebotsname ..."
        field="title"
        :loading="isFetching"
        @typing="getAsyncData"
        @select="select"
      >
        <template slot-scope="props">
          <div class="media">
            <div class="media-left">
              <img
                width="32"
                :src="
                  `https://assets.urlaubsgutschein.kaufen/${props.option.image}`
                "
              />
            </div>
            <div class="media-content">
              {{ props.option.title }}
              <br />
              <small>
                {{ props.option.contact.name }},
                {{ props.option.contact.country }} -
                {{ props.option.contact.zip }} <br />
                <p v-for="variant of props.option.variants" :key="variant.id">
                  {{ variant.nigths }} Nächte | {{ variant.persons }} Personen |
                  {{ variant.board.shortName }}
                </p>
              </small>
            </div>
          </div>
        </template>
      </b-autocomplete>
    </b-field>
  </div>
</template>

<script>
import offersApi from '@/api/offers-api'
function debounce(func, wait = 500) {
  let timeout
  return function(...args) {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      func.apply(this, args)
    }, wait)
  }
}
export default {
  name: 'OfferSelection',
  methods: {
    getAsyncData: debounce(async function(args) {
      if (!args.length) {
        this.data = []
        return
      }
      this.isFetching = true
      let data = await offersApi.getOfferTemplates(1, 20, 'default', {
        fulltextSearch: args,
        online: true,
        offline: true,
      })
      this.data = data.results
      this.isFetching = false
    }),
    select: function(option) {
      this.$emit('selected', option)
      this.selected = option
    },
  },
  data() {
    return {
      data: [],
      selected: null,
      isFetching: false,
    }
  },
}
</script>
<style lang="scss" scoped></style>
